import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import PageLayer from "@/Layouts/views/PageLayer";
import CallActivityLayer from "../CallActivity/components/CallActivityLayer";
// Icons
import CallActivityIcon from "@/assets/icons/dataPages/callActivity/CallActivity.svg";
export default function MyCallActivity() {
	const currentUser = useSelector((state: RootState) => state.user.user);

	return (
		<PageLayer title={"My Call Activity Report"} icon={CallActivityIcon}>
			<CallActivityLayer userId={currentUser?._id} />
		</PageLayer>
	);
}
